export default "__VITE_ASSET__DdlTCq7e__"